import React from "react";
import Hero from "../../components/Hero/Hero";
import { Link } from "react-router-dom";
import useMultipleFetch from "../../useMultipleFetch";
import Loading from "../../components/Loading/Loading";
import ErrorMessage from "../../components/ErrorMessage/ErrorMessage";
import CocktailsGrid from "../../components/CocktailsGrid/CocktailsGrid";
import "./home.css";
import info from "../../utils/info.json";
import Review from "../../components/Review/Review";
import heroHome from "../../assets/image/hero-home.jpg";
import ScrollToTopOnMount from "../../utils/ScrollToTop";

const Home = () => {
  const numberOfRequests = 8;

  const { isLoading, data, isError } = useMultipleFetch(numberOfRequests);

  const reviews = info.reviews.slice(-3);

  return (
    <section className="mb-5">
      <ScrollToTopOnMount />
      <Hero img={heroHome} disableOverlay={true}>
        <div className="hero">
          <div className="hero-text">
            <div className="hero-title">
              <h2 className="brand-color">The Mixologist's Playground</h2>
              <h4>
                Where cocktails and culinary delights dance together in perfect
                harmony
              </h4>
            </div>
            <p>
              Satisfy your taste buds and explore our extraordinary drink creations and more
            </p>
          </div>
        </div>
      </Hero>

      <div className="container my-5">
        <div className="row">
          <div className="col-lg-6 col-12 justify-content-center">
            <div className="containerImg">
              <div className="historyImg img1"></div>
              <div className="historyImg img2"></div>
              <div className="historyImg img3"></div>
            </div>
          </div>
          <div className="col-lg-6 col-12 ">
            <h3>Our Story</h3>
            <p>
              As cocktail lovers with a bold vision, we created this space to
              offer an extraordinary experience to those seeking more than
              just a drink. The Mixologist's Playground was born from the
              belief that cocktails are more than a beverage: they are a
              work of art to be savored.
            </p>
            <h3 className="mt-3">Our Philosophy</h3>
            <p>
              Here, every cocktail is a story told through bold flavors
              and unique combinations. Our bartenders are true artists,
              masters in the art of creating drinks that stimulate the
              senses and trigger emotions.
            </p>

            <h3 className="mt-3">Food and Atmosphere</h3>
            <p>
              It's not just our cocktail list that shines. Alongside every
              sip, we offer a menu of culinary delights designed to complete
              the experience. From small bites perfect for a snack during
              happy hour, to gourmet sandwiches that satisfy even the most
              demanding palates.
            </p>
            <h3 className="mt-3">The Playground</h3>
            <p>
              Our environment is designed to make you feel like you are in
              an alchemist's playground. Vibrant vibes, soft lighting, and
              cozy furnishings create the perfect atmosphere to share special
              moments or simply relax after a long day.
            </p>
          </div>
        </div>
      </div>

      <div className="container-sm">
        <h2 className="my-5">Featured drinks</h2>
      </div>
      <div className="container-fluid">
        {isLoading ? (
          <Loading />
        ) : isError ? (
          <ErrorMessage>No cocktail found</ErrorMessage>
        ) : data && data.length > 0 ? (
          <>
            <CocktailsGrid data={data} isFullWidth={true} />
          </>
        ) : null}
      </div>

      <div className="container-sm px-5">
        <h2 className="mt-5 mb-3">Latest reviews</h2>
        <Link to="/about#allReviews">Go to reviews section</Link>
        <div className="d-flex flex-wrap justify-content-center mt-5">
          {reviews.map((review) => {
            return (
              <Review key={review.id} review={review} showUserAvatar={false} />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Home;
